import "./controls.bundle.js";
import "./dialog.bundle.js";
import "./lib/moment.js";
import "./frappe/ui/keyboard.js";
import "./frappe/utils/datetime.js";
import "./frappe/web_form/webform_script.js";
import "./bootstrap-4-web.bundle.js";
